import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { StartMatchComponent } from './start-match.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        StartMatchComponent
    ],
    exports: [
        StartMatchComponent
    ]
})

export class StartMatchModule { }
